module.exports = Object.freeze({
  NAME: "name",
  TYPE: "type",
  VALUE: "value",
});
